export default __webpack_public_path__ + "static/media/about-11.30868859.png";